import { t } from '@lingui/core/macro';
import type { UserGroupCouponRecord } from '@navio/nsdk';

/** Usage type label from row-authoritative maxUses / spentUses / usesRemaining. */
export const getCouponUsageLabel = (coupon: UserGroupCouponRecord): string | null => {
  const { maxUses, usesRemaining, spentUses } = coupon;
  const spent: number = spentUses ?? 0;

  if (usesRemaining != null && usesRemaining === 0) {
    return null;
  }

  if (maxUses == null) {
    return t`Can be used multiple times`;
  }

  if (maxUses === 1) {
    return t`Can be used once`;
  }

  if (spent > 0) {
    return t`${spent} of ${maxUses} used`;
  }

  return t`Can be used ${maxUses} times`;
};
